import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3s5yghx62g: FaireBrandEntity = {
  token: "b_3s5yghx62g",
  type: "brand",
  name: "Creamon",
  avatarUrl:
    "https://cdn.faire.com/fastly/530ecca3c6f16bc162c2bb9d4d4b43fccd3e6a479f1c1602b03309ca57293094.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3e559f064b9f11dbfa5f30a05e8024b0935c2a1247e840c3034740b5cba45635.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/530ecca3c6f16bc162c2bb9d4d4b43fccd3e6a479f1c1602b03309ca57293094.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3e559f064b9f11dbfa5f30a05e8024b0935c2a1247e840c3034740b5cba45635.jpeg",
  location: "90021, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 27,
  isInsider: true,
  description:
    "Creamon, established in 2023, takes great pride in its origin here in the vibrant heart of DTLA. Our designs are perpetually fueled by your unique interpretations of the latest trends, blended with an essence of fashion deeply rooted in people's preferences. Our aim is to inspire trendsetters who embrace a diverse range of styles, from essential basics to accessible luxury, all of which resonate with their individuality. At Creamon, our unwavering mission is to consistently deliver designs infused with quality, confidence, and a genuine love for fashion.\n777 E 10th St Ste 105, Los Angeles, CA 90021, United States",
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:18:15.050Z",
    importedBy: "entity-db-cli",
  },
};
